// extracted by mini-css-extract-plugin
export default {"main":"PublicDataLayout_main__A5ZMB","container":"PublicDataLayout_container__B8+7F"};